import ApplicationController from "./application_controller";

// Inline enable/disable toggle for list rows.
// Sends a PATCH request to the toggle_enabled endpoint and updates the button UI.
//
export default class ToggleEnabledController extends ApplicationController {
  static targets = ['button']
  static values  = { url: String, state: Boolean }

  toggle() {
    const btn      = this.buttonTarget;
    const origHtml = btn.innerHTML;
    btn.disabled   = true;
    btn.innerHTML  = '<i class="fas fa-spinner fa-spin"></i>';

    $.ajax({
      url:      this.urlValue,
      method:   'PATCH',
      dataType: 'json',
      headers:  { 'X-CSRF-Token': this.csrfToken() },
      success:  (response) => {
        const enabled = response.enabled;
        this.stateValue = enabled;

        btn.className = `btn btn-sm ${enabled ? 'btn-success' : 'btn-outline-secondary'}`;
        btn.innerHTML = `<i class="fas ${enabled ? 'fa-toggle-on' : 'fa-toggle-off'}"></i>`;
        btn.title     = enabled ? 'Click to disable' : 'Click to enable';

        const row = this.element.closest('tr');
        if (row) { row.className = enabled ? '' : 'text-muted'; }
      },
      error: () => {
        btn.disabled  = false;
        btn.innerHTML = origHtml;
        alert('Failed to update. Please try again.');
      }
    });
  }

  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content;
  }
}
